export function enableRedirectWorkPermitFilter() {
    const filterForm = document.getElementById("filter-form") as HTMLFormElement;

    if (!filterForm) {
        console.error('No element with id "filter-form" was found');
        return;
    }

    filterForm.addEventListener("click", (e) => {
        // To prevent the filter from closing when the dropdown is clicked 
        e.stopPropagation();
    });

    filterForm.onsubmit = (e) => {
        e.preventDefault();

        const formData = new FormData(filterForm);
        const urlSearchParams = new URLSearchParams(formData as any);

        window.location.href = `/WorkPermits?Handler=byFilter&${urlSearchParams}`;
    };
}
